import React from 'react';
import HeaderBanner from '../HeaderBanner/HeaderBanner';


const Header = () => {
    return (
        <div>
            <HeaderBanner/>
        </div>
    );
};

export default Header;